<template>
  <div class="bg-white rounded-lg border border-gray-200 p-5 space-y-4 animate-pulse">
    <div class="flex items-center justify-between">
      <div class="h-4 bg-gray-200 rounded w-3/4"></div>
      <div class="h-4 bg-gray-200 rounded w-1/6"></div>
    </div>
    <div class="space-y-2">
      <div class="h-3 bg-gray-200 rounded w-1/2"></div>
      <div class="h-3 bg-gray-200 rounded w-1/3"></div>
      <div class="h-3 bg-gray-200 rounded w-1/2"></div>
    </div>
    <div class="flex gap-2">
      <div class="h-5 bg-gray-200 rounded w-1/4"></div>
      <div class="h-5 bg-gray-200 rounded w-1/4"></div>
      <div class="h-5 bg-gray-200 rounded w-1/4"></div>
    </div>
    <div class="border-t border-gray-200 pt-3">
      <div class="h-9 bg-gray-200 rounded-md w-full"></div>
    </div>
  </div>
</template>